import { Component, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-order-success',
  templateUrl: './order-success.component.html',
  styleUrls: ['./order-success.component.scss']
})
export class OrderSuccessComponent implements OnInit {

  constructor(
		private renderer: Renderer2,
    private router : Router, 
  ) { }

  ngOnInit(): void {

    this.addGoogleTag();

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        console.log("itemskjdfnskd");
        this.addGoogleTag()
	}})
  }

  addGoogleTag(){
    
         	// Add the event snippet for Lagos Events Conversion
           const lagosEventScript = this.renderer.createElement('script');
           // lagosEventScript.text = `gtag('event', 'conversion', {'send_to': 'AW-475162407/odOBCO3-1_UBEKfOyeIB'});`;
           this.renderer.appendChild(document.head, lagosEventScript);
     
     // Add the event snippet for Purchase Conversion
     const purchaseEventScript = this.renderer.createElement('script');
     // const item = this.selectedDeliveryMethod?.dropPoint?.length ? this.selectedDeliveryMethod.dropPoint.map(((item, i) => {
       const item = {
         'item_id': '654879',
         'item_name' : 'egg',
         'affiliation': "phlenu",
         'coupon': '',
         'discount' : '20',
         'index' : 1,
         'item_brand': "Google",
         'item_category' : 'pharmacy',
         'price' : '1200',
         'quantity' : '1'
       } 
     purchaseEventScript.text = `
     gtag('event', 'purchase', {
       'send_to': 'GTM-PLHCG6G7/odOBCO3-1_UBEKfOyeIB'
       'email' : 'jagdishseervi@gts.com,
       'phone' : 'phone', 
       'ecommerce' : {
         'transaction_id': '123456'},
         'value' : '514',
         'tax' : '10',
         'shipping': '',
         'currency' : 'GHS',
         'price', : '2100',
         'coupon': '',
         'items': ${JSON.stringify(item)}}
       }
     })`
     this.renderer.appendChild(document.head, purchaseEventScript); 
 
  }

}
